export default "<span class=\"indicator\" [style]=\"{'background-cOlor': state ? color : 'gray'}\"></span>\n";